import { observer } from "mobx-react";
import * as React from "react";
import { Async } from "react-async";
import { Button } from "../../../../../../../../components/ui/Button";
import { Pill, PillTypes } from "../../../../../../../../components/ui/Pill";
import { PositionedSpinner } from "../../../../../../../../components/ui/PositionedSpinner";
import { CanEdit } from "../../../../../../../../contexts/permissions/PermissionHelpers";
import { PermissionFields } from "../../../../../../../../contexts/permissions/PermissionsTypes";
import { useFlightPathUser } from "../../../../../../../auth_insight";
import I18n from "../../../../../../../localization/I18n";
import { useModalContext } from "../../../../../../../modalZ/context/ModalContext";
import { ProgressStatus, Translator } from "../../../../../../../../enums";
import { CommentListViewModel } from "../../../../../../../../pages/change/comments/commentListView/CommentListView_model";
import { CommentListView } from "../../../../../../../../pages/change/comments/commentListView/CommentListView_view";
import ActionsApi from "../../../../../../../../services/api/v2/actions/Actions.api";

export interface ActionNotesSidebarModel {
  projectId: number;
  actionId: number;
  organisationId: number;
}

export const ActionNotesSidebar: React.FunctionComponent<ActionNotesSidebarModel> = observer(p => {
  let [action, setAction] = React.useState(null);
  const authUser = useFlightPathUser();
  const projectId = p.projectId;
  const actionId = p.actionId;
  const organisationId = p.organisationId;
  const modalService = useModalContext();
  const actionsProvider = ActionsApi;

  const listViewConfig = React.useMemo(() => {
    return {
      searchAttribute: "actionId",
      id: -1,
      title: null,
      projectId: projectId,
      organisationId: organisationId,
      placeholderText: I18n.t("placeholders.actionNotePlaceholder")
    };
  }, [projectId, organisationId]);

  const commentViewModel = React.useMemo(
    () => new CommentListViewModel(projectId, authUser, listViewConfig),
    [projectId, authUser, listViewConfig]
  );

  const load = React.useCallback(async () => {
    const res = await actionsProvider.getDetailedByIdAsync(organisationId, projectId, actionId);

    if (!res || res.isError) {
      return;
    }

    setAction(res.payload);
    commentViewModel.setConfig({
      id: res.payload.id
    });
  }, [actionId, projectId, organisationId, commentViewModel, actionsProvider]);
  let pillType = action?.progressStatus === ProgressStatus.NOT_STARTED ? PillTypes.LIGHT_GRAY : PillTypes.GRAY;
  return (
    <Async promiseFn={load}>
      <Async.Loading>
        <PositionedSpinner />
      </Async.Loading>
      <Async.Resolved>
        {() => (
          <div className="container-fluid action-compact-view">
            <div className="row mb-6">
              <div className="col">
                <div className="d-flex align-items-center flex-row-reverse">
                  <Pill type={pillType}>{Translator.ProgressStatus(action.progressStatus)}</Pill>
                </div>
              </div>
            </div>
            <CanEdit projectId={projectId} field={PermissionFields.ACTIONS}>
              <div className="row mb-0">
                <div className="col">
                  <h3 className="mb-0 pl-0 pb-0">{I18n.t("phrases.addANote")}</h3>
                </div>
              </div>
            </CanEdit>
            <CommentListView model={commentViewModel} field={PermissionFields.ACTIONS} />
            <div className="row mb-5">
              <div className="col">
                <div className="d-flex">
                  <Button
                    className="ml-auto"
                    onClick={() => {
                      modalService.hide();
                    }}
                  >
                    {I18n.t("phrases.done")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Async.Resolved>
    </Async>
  );
});
